export default __webpack_public_path__ + "static/media/img_upee_c-min.adaf0148.jpg";